import React from 'react';

// Navigation
import NavCrumbs from 'routes/dashboard/nav-crumbs';

export default function (props) {

  let { client } = props;

  let crumbs = [
        {name: 'Clients', path: 'resourcing-clients'},
        {name: 'All Clients', path: 'resourcing-clients/all'},
        {name: '...', path: '#'},
  ];

  if (client != null) {
    crumbs[2] =  { name: `${client.title}`, path: `resourcing-clients/${client._id}` }
  };

  return (
   <div>
       <NavCrumbs crumbs={crumbs} />
       {props.children}
   </div>
  )
}
